import React, { Component, Fragment } from 'react';
import moment from 'moment';
import cx from 'classnames';
import { Query } from '../../reactApolloCompat';
import { IconButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Grid from './Grid';
import TextField from './TextField';
import Table, { TableCell, TableHeaderCell, TableHeaderRow, TableRow } from './Table';
import { joinDefined, pad } from '../../util/strings';
import { dateToString, niceTimeFromString, shortDateFromString, stringToDate } from '../../util/date';
import { InlineField } from './Inline';
import StaffAutoComplete from './StaffAutoComplete';
import { AltButton, OutlineButton } from './PrimaryButton';
import { getClient } from '../../apollo';
import gql from 'graphql-tag';
import Spinner from '../Spinner';
import { deleteTypeName } from '../../util/objects';
import { DeleteIcon, EditIcon, TickCircleIcon } from '../IconIndex';

class StaffAllocationTable extends Component {
    state = {
        loading: false,
        editField: null,
        editClone: null,
        editIndex: null
    };

    render() {
        const { classes, staffAllocations, showCalendarLink, date, disabled } = this.props;
        const { editIndex, editClone, loading } = this.state;
        return (
            <Fragment>
                {staffAllocations.length > 0 && (
                    <Fragment>
                        <Grid item xs={12}>
                            <Table className="no-responsive">
                                <TableHeaderRow>
                                    <TableHeaderCell>Staff Allocation</TableHeaderCell>
                                    <TableHeaderCell>Arrive</TableHeaderCell>
                                    <TableHeaderCell>Leave</TableHeaderCell>
                                    <TableHeaderCell className={classes.tinyCell} />
                                </TableHeaderRow>
                                {staffAllocations.map((obj, i) =>
                                    editIndex === i ? (
                                        <TableRow key={i}>
                                            <TableCell colSpan={3}>
                                                <div className={classes.editCell}>
                                                    <StaffAutoComplete
                                                        preloadAll
                                                        defaultMe={false}
                                                        clearOnSelect={false}
                                                        label="Select a staff member"
                                                        disabled={disabled}
                                                        placeholder={'Search for staff by name...'}
                                                        value={editClone.Member}
                                                        maxHeight={222} // restricted height due to table overflow
                                                        limit={5} // restricted height due to table overflow
                                                        onSelect={(_, result) =>
                                                            this.onEditField(
                                                                'Member',
                                                                result
                                                                    ? {
                                                                          Email: result.Email,
                                                                          FirstName: result.FirstName,
                                                                          ID: result.ID,
                                                                          Surname: result.Surname
                                                                      }
                                                                    : null
                                                            )
                                                        }
                                                    />
                                                    <TextField
                                                        InputLabelProps={{ shrink: true }}
                                                        label="Instructions"
                                                        multiline
                                                        placeholder={'Enter any notes...'}
                                                        value={editClone.Allocation}
                                                        onChange={e => this.onEditField('Allocation', e.target.value)}
                                                    />
                                                    <InlineField>
                                                        <TextField
                                                            label="Arrive"
                                                            disabled={disabled}
                                                            type="time"
                                                            value={editClone.TimeFrom}
                                                            onChange={e => this.onEditField('TimeFrom', e.target.value)}
                                                        />
                                                        <TextField
                                                            label="Leave"
                                                            disabled={disabled}
                                                            type="time"
                                                            value={editClone.TimeTo}
                                                            onChange={e => this.onEditField('TimeTo', e.target.value)}
                                                        />
                                                    </InlineField>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className={classes.verticalButtons}>
                                                    <IconButton
                                                        className={cx(classes.iconButton)}
                                                        title={'Accept'}
                                                        onClick={() => this.onCancelEditRow()}
                                                        size="large"
                                                    >
                                                        <TickCircleIcon className={classes.icon} />
                                                    </IconButton>

                                                    <IconButton
                                                        disabled={disabled}
                                                        className={cx(classes.iconButton)}
                                                        title={'Remove'}
                                                        onClick={() => this.onDeleteRow(i)}
                                                        size="large"
                                                    >
                                                        <DeleteIcon className={classes.icon} />
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        <TableRow key={i}>
                                            <TableCell>
                                                <div className={classes.readonlyCell}>
                                                    {(obj.Member && this.showMember(obj.Member)) || (
                                                        <span className={classes.notSpecified}>
                                                            Staff Not Allocated
                                                        </span>
                                                    )}
                                                    <small>
                                                        <br />
                                                        {obj.Allocation}
                                                    </small>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className={classes.readonlyCell}>
                                                    {niceTimeFromString(obj.TimeFrom)}
                                                    {moment(date).date() !== moment(obj.Start).date() && (
                                                        <small>
                                                            <br />
                                                            {shortDateFromString(obj.Start)}
                                                        </small>
                                                    )}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className={classes.readonlyCell}>
                                                    {niceTimeFromString(obj.TimeTo)}
                                                    {moment(date).date() !== moment(obj.End).date() && (
                                                        <small>
                                                            <br />
                                                            {shortDateFromString(obj.End)}
                                                        </small>
                                                    )}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ whiteSpace: 'nowrap' }}>
                                                    <IconButton
                                                        className={classes.iconButton}
                                                        title={'Edit'}
                                                        onClick={() => this.onEditRow(i)}
                                                        size="large"
                                                    >
                                                        <EditIcon className={classes.icon} />
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )
                                )}
                            </Table>
                        </Grid>
                    </Fragment>
                )}
                <Grid item xs={12}>
                    <InlineField lineHeight={'normal'}>
                        <AltButton disabled={!date || loading || disabled} onClick={() => this.onAddRow()}>
                            {loading ? (
                                <Fragment>
                                    <Spinner />
                                    &nbsp;Loading Staff...
                                </Fragment>
                            ) : (
                                '+ Add Staff Allocation'
                            )}
                        </AltButton>
                        {showCalendarLink && (
                            <OutlineButton target="_blank" onClick={() => this.openCalendar()}>
                                Open Calendar
                            </OutlineButton>
                        )}
                    </InlineField>
                </Grid>
            </Fragment>
        );
    }

    openCalendar() {
        const date = this.props.date ? '/' + this.props.date.replace(/-/g, '').trim() : '';
        const url = `/calendar${date}`;
        const win = window.open(url, '_blank');
        win.focus();
    }

    onEditField(fieldName, value) {
        const { editClone } = this.state;
        editClone[fieldName] = '' === value ? null : value;
        this.setState({ editClone });
        this.onSaveRow();
    }

    onSaveRow() {
        const { onChange } = this.props;
        const { editClone, editIndex } = this.state;

        if (onChange) onChange(editIndex, editClone);
    }

    onCancelEditRow() {
        this.setState({ editIndex: null, editClone: null });
    }

    onEditRow(index) {
        if (this.state.editIndex) this.onSaveRow();

        const { staffAllocations } = this.props;
        this.setState({ editIndex: index, editClone: { ...staffAllocations[index] } });
    }

    onDeleteRow(index) {
        const { onDelete } = this.props;

        if (!onDelete) return;

        onDelete(index);
        this.onCancelEditRow();
    }

    getTimesForStaff() {
        const { date, startTime, endTime, duration, buffer } = this.props;
        if (!(!!date && moment(date).isValid())) return;
        const theDate = dateToString(date);

        const minuteBuffer = buffer || 60; // staff starts 1 hour before event
        const durationBuffer = duration || 4; // staff is minimum four hours

        let startTimeString = startTime;
        if (!startTimeString) startTimeString = '09:30:00';
        else if (startTimeString.length === 5) startTimeString += ':00';
        else if (startTimeString.length !== 8)
            throw new Error('unexpected start time format ' + startTimeString + '. Expected=HH:mm:ss');

        const startDateTime = stringToDate(`${theDate} ${startTimeString}`);
        const adjustedStartTime = new Date(startDateTime.getTime() - minuteBuffer * 60000);

        let adjustedEndTime;
        if (endTime) {
            let endTimeString = endTime;
            if (endTimeString.length === 5) endTimeString += ':00';
            else if (endTimeString.length !== 8)
                throw new Error('unexpected end time format ' + endTimeString + '. Expected=HH:mm:ss');

            const endDateTime = stringToDate(`${theDate} ${endTimeString}`);
            adjustedEndTime = new Date(endDateTime.getTime() + minuteBuffer * 60000);
        } else {
            adjustedEndTime = new Date(startDateTime.getTime() + minuteBuffer * 60000 + durationBuffer * 60 * 60000);
        }

        const TimeFrom = `${pad(adjustedStartTime.getHours(), 2)}:${pad(adjustedStartTime.getMinutes(), 2)}:00`;
        const TimeTo = `${pad(adjustedEndTime.getHours(), 2)}:${pad(adjustedEndTime.getMinutes(), 2)}:00`;
        const DateFrom = dateToString(adjustedStartTime);
        const DateTo = dateToString(adjustedEndTime);
        return { TimeFrom, TimeTo, DateFrom, DateTo };
    }

    onAddRow() {
        const { onAdd, disabled, staffAllocations = [] } = this.props;
        const { TimeFrom, TimeTo, DateFrom, DateTo } = this.getTimesForStaff();
        if (staffAllocations.length === 0) {
            if (disabled) {
                onAdd({});
            } else {
                const that = this;
                that.setState({ loading: true });
                this.getDefaultStaffMembers().then(data => {
                    const Members = that.getFuneralStaff(data);
                    if (Members && Members.length) {
                        Members.forEach(m => onAdd({ Member: m, TimeFrom, TimeTo, DateFrom, DateTo }));
                    } else onAdd({ Member: null, TimeFrom, TimeTo, DateFrom, DateTo });
                    that.setState({
                        loading: false,
                        editIndex: Members && Members.length ? null : 0,
                        editClone: { TimeFrom, TimeTo }
                    });
                });
            }
        } else {
            onAdd({ Member: null, TimeFrom, TimeTo, DateFrom, DateTo });
            this.setState({ editIndex: staffAllocations.length - 1, editClone: { TimeFrom, TimeTo } });
        }
    }

    getFuneralStaff = data => {
        const conductors = data && data.Conductors;
        const arrangers = data && data.Arrangers;
        if (!(conductors || arrangers)) return null;
        if (!((conductors && conductors.length > 0) || (arrangers && arrangers.length > 0))) return null;

        const staff = [];
        const staffIDs = []; // checks for dupes
        for (let x = 0; x < conductors.length; x++) {
            if (!staffIDs[conductors[x].Member.ID]) {
                staff.push(conductors[x].Member);
                staffIDs[conductors[x].Member.ID] = true;
            }
        }
        for (let x = 0; x < arrangers.length; x++) {
            if (!staffIDs[arrangers[x].Member.ID]) {
                staffIDs[arrangers[x].Member.ID] = true;
                staff.push(arrangers[x].Member);
            }
        }

        return deleteTypeName(staff);
    };

    getDefaultStaffMembers = async () => {
        const { funeralId } = this.props;
        if (!funeralId) return null;
        const funeralStaff = await getClient().query({
            query: ReadStaffAllocateQuery,
            variables: { funeralId }
        });
        return funeralStaff.data && funeralStaff.data.readOneFuneral;
    };

    showMember = Member => {
        const { funeralId } = this.props;
        return (
            <Query query={ReadStaffAllocateQuery} variables={{ funeralId }}>
                {({ data, loading, error }) => {
                    if (!data || loading || error) return null;
                    const conductor =
                        data.readOneFuneral && data.readOneFuneral.Conductors.find(o => Member.ID === o.Member.ID);
                    const arranger =
                        data.readOneFuneral && data.readOneFuneral.Arrangers.find(o => Member.ID === o.Member.ID);
                    return (
                        <Fragment>
                            {joinDefined([Member.FirstName, Member.Surname], ' ')}
                            {(conductor || arranger) && ' ('}
                            {(conductor &&
                                ((conductor.Allocation && conductor.Allocation + ' ') || '') + 'Conductor') ||
                                (arranger && ((arranger.Allocation && arranger.Allocation + ' ') || '') + 'Arranger')}
                            {(conductor || arranger) && ')'}
                        </Fragment>
                    );
                }}
            </Query>
        );
    };
}

const ReadStaffAllocateQuery = gql`
    query ReadFuneralStaff($funeralId: ID!) {
        readOneFuneral(ID: $funeralId) {
            ID
            Arrangers {
                ID
                Allocation
                Member {
                    ID
                    FirstName
                    Surname
                }
            }
            Conductors {
                ID
                Allocation
                Member {
                    ID
                    FirstName
                    Surname
                }
            }
        }
    }
`;

const styles = ({ palette }) => ({
    iconButton: {
        height: '24px',
        width: '24px'
        //marginTop: '12px'
    },
    icon: {
        height: '18px',
        width: '18px',
        verticalAlign: 'middle'
    },
    readonlyCell: {
        margin: '10px 0'
    },
    editCell: {
        margin: '4px 0'
    },
    verticalButtons: {
        height: '100%',
        '& > button': {
            margin: '1rem 0',
            '&.confirm': {
                color: palette.validation.good
            },
            '&.revert': {
                color: palette.validation.suggested
            },
            '&.remove': {
                color: palette.validation.error
            }
        }
    },
    tinyCell: {
        width: 1
    },
    notSpecified: {
        fontStyle: 'italic',
        color: '#777'
    },
    viewCalendarButton: {
        float: 'right'
    },
    readOnlyLabel: {
        color: '#000',
        fontWeight: '500',
        fontSize: '0.95em',
        display: 'inline-block'
    },
    readOnlyBucket: {
        margin: '11px 0',
        '&>div>div.button-base.tag.with-delete': {
            maxWidth: '100%',
            justifyContent: 'left',
            flexDirection: 'row-reverse'
        }
    }
});

export default withStyles(styles)(StaffAllocationTable);
